import { createUseStyles } from 'react-jss'

import colors from 'src/config/colors'

import hexToRGBA from 'src/helpers/hexToRGBA'

import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  spinner: {
    width: '1rem',
    height: '1rem',
    borderRadius: '50%',
    border: `0.1rem solid ${hexToRGBA(colors.cornFlowerBlue, '0.1')}`,
    borderTopColor: colors.cornFlowerBlue,
    animationName: '$spin',
    animationDuration: '1.5s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    '&$centered': {
      margin: [30, 'auto'],
      width: 25,
      height: 25,
      [forPhoneOnly]: {
        position: 'fixed',
        left: 'calc(50% - 12.5px)',
        top: 'calc(50% - 62.5px)',
      },
    },
    '&$large': {
      width: '2rem',
      height: '2rem',
    },
  },
  '@keyframes spin': {
    to: {
      transform: 'rotate(360deg)',
    },
  },
  centered: {},
  large: {},
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: theme.palette.grey['100'],
    opacity: 0.9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
}))
